import { useQuery } from '@tanstack/react-query';

import { withGlobalError } from '@/react-tools/react-query';
import { EnvironmentId } from '@/react/portainer/environments/types';
import axios, { parseAxiosError } from '@/portainer/services/axios';

import { CustomResource } from '../types';

import { queryKeys } from './query-keys';

export function useCustomResources(
  environmentId: EnvironmentId,
  definition: string,
  options?: { refetchInterval?: number }
) {
  return useQuery(
    queryKeys.customResources(environmentId, definition),
    () => getCustomResources(environmentId, definition),
    {
      enabled: !!environmentId && !!definition,
      refetchInterval: options?.refetchInterval,
      ...withGlobalError('Unable to retrieve custom resources'),
    }
  );
}

async function getCustomResources(
  environmentId: EnvironmentId,
  definition: string
): Promise<CustomResource[]> {
  try {
    const { data } = await axios.get<CustomResource[]>(
      `/kubernetes/${environmentId}/customresources`,
      {
        params: { definition },
      }
    );
    // API returns data directly as an array, not wrapped in an items property
    return Array.isArray(data) ? data : [];
  } catch (err) {
    throw parseAxiosError(err, 'Unable to retrieve custom resources');
  }
}
